import * as React from "react";
import { useRouter } from "next/router";
import { LoaderScreen } from "@grandvisionhq/common";
import { useDispatch } from "@grandvisionhq/state";
import { logSignInEvent } from "../../data-layer/data-layer/sign-in.js";
import { useAccountLoginTracking } from "../../hooks/hooks/use-account-login-tracking.js";
import { useSocialLoginMethod } from "../../hooks/hooks/use-social-login-method.js";
import { loggedOut } from "../../Logout/Logout/actions.js";
import { parseHash } from "./actions.js";
const Callback = ({ type }) => {
  const dispatch = useDispatch();
  const { asPath: callbackReturnPath, query } = useRouter();
  const { handleSocialLogin } = useSocialLoginMethod();
  useAccountLoginTracking({ queryLoginMethod: query.loginMethod, type });
  React.useEffect(() => {
    if (query.loginMethod === "social") {
      handleSocialLogin();
    } else {
      if (type === "callback") {
        dispatch(parseHash());
        logSignInEvent();
      }
      if (type === "logged-out") {
        dispatch(loggedOut(callbackReturnPath));
      }
    }
  }, [callbackReturnPath, dispatch, handleSocialLogin, query.loginMethod, type]);
  return /* @__PURE__ */ React.createElement(LoaderScreen, { height: 50 });
};
export {
  Callback as default
};
//# sourceMappingURL=Callback.js.map
